import moment from 'moment';
import { DonationDateRangeOption } from './models';

export interface IDonationDayOption {
	key: string;
	label: string;
	value: string;
	/** Upper bound date for the range (today for duration options, end-of-period for ThisYear/LastYear) */
	maxValue?: string;
}

/** Returns fresh donation day options with dates computed at call time (avoids stale dates across midnight). */
export function getDonationDayOptions(): IDonationDayOption[] {
	const options: IDonationDayOption[] = [];

	// Duration-based options
	const durationOptions: { key: string; label: string; amount: number; unit: moment.unitOfTime.DurationConstructor }[] =
		[
			{ key: 'OneMonth', label: DonationDateRangeOption.OneMonth, amount: 1, unit: 'months' },
			{ key: 'ThreeMonths', label: DonationDateRangeOption.ThreeMonths, amount: 3, unit: 'months' },
			{ key: 'SixMonths', label: DonationDateRangeOption.SixMonths, amount: 6, unit: 'months' },
			{ key: 'OneYear', label: DonationDateRangeOption.OneYear, amount: 1, unit: 'years' },
			{ key: 'ThreeYears', label: DonationDateRangeOption.ThreeYears, amount: 3, unit: 'years' },
		];

	const today = moment().format('YYYY-MM-DD');

	for (const opt of durationOptions) {
		options.push({
			key: opt.key,
			label: opt.label,
			value: moment().subtract(opt.amount, opt.unit).format('YYYY-MM-DD'),
			maxValue: today,
		});
	}

	// This Year: Jan 1 current year → today
	options.push({
		key: 'ThisYear',
		label: DonationDateRangeOption.ThisYear,
		value: moment().startOf('year').format('YYYY-MM-DD'),
		maxValue: moment().format('YYYY-MM-DD'),
	});

	// Last Year: Jan 1 last year → Dec 31 last year
	options.push({
		key: 'LastYear',
		label: DonationDateRangeOption.LastYear,
		value: moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'),
		maxValue: moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD'),
	});

	// Custom Range
	options.push({
		key: 'Custom',
		label: DonationDateRangeOption.Custom,
		value: DonationDateRangeOption.Custom,
	});

	return options;
}
